import {combineLatest, Observable} from 'rxjs';
import {map, mergeMap, take} from 'rxjs/operators';
import {Injectable, inject} from '@angular/core';
import {DialogConfiguration} from './dialogconfiguration';
import {FilterResult} from '../../resource/filterresult';
import {BaseApiService} from '../../core/services/base-api.service';
import {SupportedLocaleConfigurationService} from './supportedlocaleconfiguration.service';
import {EnvironmentConfigService} from '../../core/services/environment-config.service';

@Injectable()
export class DialogConfigurationService extends BaseApiService {
  private localeService = inject(SupportedLocaleConfigurationService);

  public getDialogConfigurations(): Observable<DialogConfiguration[]> {
    const attributes = [
      this.getAttr('ObjectID'),
      this.getAttr('DisplayName'),
      this.getAttr('Description'),
      this.getAttr('TargetObjectType'),
      this.getAttr('AppliesToCreate'),
      this.getAttr('AppliesToWizard'),
      this.getAttr('AppliesToEdit'),
      this.getAttr('UIConfiguration'),
      this.getAttr('Configuration'),
      this.getAttr('UISync'),
      this.getAttr('StringResources'),
      this.getAttr('UrlID'),
    ].filter(x => x != null);

    return this.getWithLocale<FilterResult>(
      '/' + this.getType('ViewConfiguration'),
      attributes,
      10000,
      this.localeService.getSupportedLocaleConfiguration(),
    ).pipe(map(response => this.toDialogConfigurations(response.Results)));
  }

  private toDialogConfigurations(navbars: any): DialogConfiguration[] {
    let finalNavbars: DialogConfiguration[] = [];
    navbars.forEach(obj => {
      finalNavbars.push(this.toDialogConfiguration(obj));
    });
    return finalNavbars;
  }

  private toDialogConfiguration(r: any): DialogConfiguration {
    const uiSyncAttr = this.getAttr('UISync');
    const configAttr = this.getAttr('Configuration');
    const uiConfigAttr = this.getAttr('UIConfiguration');

    if (uiSyncAttr && r[uiSyncAttr] && r[uiSyncAttr] === 'Sync') {
      return <DialogConfiguration>{
        id: r[this.getAttr('ObjectID')],
        displayname: r[this.getAttr('DisplayName')],
        description: r[this.getAttr('Description')],
        objecttype: r[this.getAttr('TargetObjectType')],
        edit: r[this.getAttr('AppliesToEdit')],
        create: r[this.getAttr('AppliesToCreate')],
        wizard: r[this.getAttr('AppliesToWizard')],
        configuration: r[configAttr],
        stringresources: r[this.getAttr('StringResources')],
        urlid: r[this.getAttr('UrlID')],
      };
    } else {
      return <DialogConfiguration>{
        id: r[this.getAttr('ObjectID')],
        displayname: r[this.getAttr('DisplayName')],
        description: r[this.getAttr('Description')],
        objecttype: r[this.getAttr('TargetObjectType')],
        edit: r[this.getAttr('AppliesToEdit')],
        create: r[this.getAttr('AppliesToCreate')],
        wizard: r[this.getAttr('AppliesToWizard')],
        configuration: r[uiConfigAttr],
        stringresources: r[this.getAttr('StringResources')],
        urlid: r[this.getAttr('UrlID')],
      };
    }
  }
}
